import React, { useContext, useState } from 'react';
import styles from './ZavrsniRadoviFilterToggleButton.module.css';
import { ReactComponent as FilterExpand } from '../assets/filter-expand.svg';
import { ReactComponent as FilterCollapse } from '../assets/filter-collapse.svg';
import { ThemeContext } from '../contexts/ThemeContext';

const ZavrsniRadoviFilterToggleButton = ({ toggleFilterMenu }) => {
  const { dark } = useContext(ThemeContext);
  const [ expand, setExpand ] = useState(false);

  const toggleMenu = () => {
    toggleFilterMenu();
    setExpand(!expand);
  }

  return (
    <div className={dark ? styles.filterMenuContainerDark : styles.filterMenuContainerLight} onClick={ toggleMenu }>
      {expand ? (
          <FilterExpand
            className={dark ? styles.filterIconDark : styles.filterIconLight}/>
      ) : (
          <FilterCollapse
            className={dark ? styles.filterIconDark : styles.filterIconLight}/>
        )}
      Filter
    </div>
  );
}

export default ZavrsniRadoviFilterToggleButton;